// SUNDAY BATCH · agent A — screen texts, EN + AR (merged into lib/i18n.js translations; big-file rule).
//   FX2-3  the coded refusal of PUT /engagements/{id}/first-year when the engagement is not saved as "Initial engagement"
//          (toErrMsg reads errors.<CODE> for a non-English screen). The full reason under the toggle and the FX2-2 red
//          warning "Prior-year data exists - clear the first-year flag" come from the server in EN + AR (first_year.py).
export const I18N_SBA = {
  en: {
    errors: {
      FIRST_YEAR_NOT_INITIAL_ENGAGEMENT: "Only an engagement saved as \"Initial engagement\" (ISA 510) can be marked \"First-year engagement - no comparatives\".",
    },
  },
  ar: {
    errors: {
      FIRST_YEAR_NOT_INITIAL_ENGAGEMENT: "لا يمكن تحديد \"ارتباط السنة الأولى - بدون أرقام مقارنة\" إلا لارتباط محفوظ بوصفه \"ارتباط أولي\" (معيار المراجعة الدولي 510).",
    },
  },
};

export default I18N_SBA;
